// extracted by mini-css-extract-plugin
module.exports = {"figureCaption":"FigureCaption_figureCaption__3HRfN","figureCaptionContents":"FigureCaption_figureCaptionContents__3T_pn"};